import dynamic from "next/dynamic";
import Sidebar from "./Sidebar/Sidebar";
import Footer from "./Footer";
import { Theme } from "@mui/material";
import {
  PartnerPromoCodes,
  Partners,
  ReactComponentContainer,
} from "@/core/types/types";
import { useTheme } from "@mui/material/styles";
import { useMediaQuery } from "@mui/material";
import { Box } from "@mui/system";
import UpperFooter from "./UpperFooter";
import { useWindowSize } from "@/core/hooks/useWindowSize";
import useCustomStyles from "@/core/hooks/useCustomStyles/useCustomStyles";
import { isBrandingPartner } from "@/utils";
import { partnerPromoCodes } from "@/core/data";
import { useEffect, useState } from "react";

const DynamicHeader = dynamic(() => import("./Header"), {
  ssr: false,
});

const styles = (theme: Theme) => ({
  root: {
    position: "relative",
    width: "100%",
    minHeight: "100%",
    display: "flex",
    flexDirection: "column",
    background: theme.palette.secondary.light,
    color: theme.palette.text.primary,
  },
  viewport: {
    minHeight: "calc(100vh - 170px)",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    [theme.breakpoints.up("md")]: {
      minHeight: "calc(100vh - 100px)",
      flexDirection: "row",
    },
  },
  main: {
    padding: theme.spacing(2, 2, 4),
    alignSelf: "stretch",
    flexBasis: "100%",
    display: "flex",
    justifyContent: "center",
  },
});

interface LayoutProps extends ReactComponentContainer {
  promoCode: string;
}

const Layout = ({ brandName, promoCode, children }: LayoutProps) => {
  const theme: Theme = useTheme();
  const isDesktop: boolean = useMediaQuery(theme.breakpoints.up("md"));
  const classes: any = useCustomStyles(styles);
  const { position, marginLeft } = useWindowSize();
  const partnerPromoCode: PartnerPromoCodes | null = isBrandingPartner(
    promoCode
  )
    ? (promoCode as PartnerPromoCodes)
    : null;
  const partner: Partners | null =
    partnerPromoCode !== null ? partnerPromoCodes[partnerPromoCode] : null;

  const [isSidebarReady, setIsSidebarReady] = useState(false);

  useEffect(() => {
    if (typeof window !== "undefined") {
      setTimeout(() => {
        setIsSidebarReady(true);
      }, 0);
    } else {
      setIsSidebarReady(true);
    }
  }, []);

  return (
    <section>
      <Box sx={classes?.root}>
        {!isDesktop && (
          <DynamicHeader brandName={brandName} partnerId={partner} />
        )}

        <Box sx={classes?.viewport}>
          {isDesktop && (
            <Sidebar
              position={position}
              brandName={brandName}
              partnerId={partner}
            />
          )}

          {isSidebarReady && (
            <Box sx={[classes?.main]}>
              <Box sx={{ marginLeft }}>{children}</Box>
            </Box>
          )}

          {!isDesktop && (
            <UpperFooter
              brandName={brandName}
              isSideBarReady={isSidebarReady}
            />
          )}
        </Box>

        <Footer />
      </Box>
    </section>
  );
};

export default Layout;
